import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-toxicology-results',
  templateUrl: './toxicology-results.component.html',
  styleUrls: ['./toxicology-results.component.scss']
})
export class ToxicologyResultsComponent implements OnInit {

  @Input() public orderId: number = -1;
  public isLoading = false;
  @Output() public hasUnexpectedPositive = new EventEmitter();

  public ngOnInit() {
    this.isLoading = true;
  }

  public hasUnexpectedPositiveResults(hasResults: boolean) {
    this.hasUnexpectedPositive.emit(hasResults);
  }

}
